var React = require('react');

function CompanyHeroFlag3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m58.8486059 31.3410356h206.1880521l67.811948 143.0000004h-274.0000001z","fill":"#4eb684","fillRule":"evenodd","opacity":".05","transform":"matrix(-1 0 0 1 333.5 -30.664969)"}));
}

CompanyHeroFlag3.defaultProps = {"height":"144","viewBox":"0 0 275 144","width":"275"};

module.exports = CompanyHeroFlag3;

CompanyHeroFlag3.default = CompanyHeroFlag3;
